import { render } from "./NewAttendant.vue?vue&type=template&id=e01fb1ec"
import script from "./NewAttendant.vue?vue&type=script&lang=js"
export * from "./NewAttendant.vue?vue&type=script&lang=js"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__